import type { ArticleImageType, BlogItemImage } from "@jti/fe-common";

export const getImageSource = (image: ArticleImageType, title: string): BlogItemImage | null => {
  if (image && ("fileReference" in image || "file" in image)) {
    const fileReference = image.fileReference || image.file;
    if (!fileReference) return null;
    return {
      smallReference: fileReference,
      mediumReference: fileReference,
      largeReference: fileReference,
      altText: title,
    };
  }

  if (image && ("smallReference" in image || "mediumReference" in image || "largeReference" in image)) {
    const imageObject = image as BlogItemImage;
    return {
      smallReference: imageObject?.smallReference || imageObject?.mediumReference || imageObject?.largeReference,
      mediumReference: imageObject?.mediumReference || imageObject?.largeReference || imageObject?.smallReference,
      largeReference: imageObject?.largeReference || imageObject?.mediumReference || imageObject?.smallReference,
      altText: imageObject?.altText || title,
    };
  }

  return null;
};
